<ng-template #ic let-name="name" let-size="size" let-sw="sw">
  <svg
    [attr.width]="size || 18"
    [attr.height]="size || 18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    [attr.stroke-width]="sw || 1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    @switch (name) {
      @case ('close') {
        <path d="M18 6 6 18M6 6l12 12" />
      }
      @case ('plus') {
        <path d="M12 5v14M5 12h14" />
      }
      @case ('folder') {
        <path d="M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z" />
      }
      @case ('expand') {
        <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3m13-5v3a2 2 0 0 0-2 2h-3" />
      }
      @case ('shrink') {
        <path d="M9 9 4 4m0 5V4h5m6 5 5-5m0 5V4h-5M9 15l-5 5m0-5v5h5m6-5 5 5m0-5v5h-5" />
      }
      @case ('chev') {
        <path d="m6 9 6 6 6-6" />
      }
      @case ('clip') {
        <path
          d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
        />
      }
      @case ('mic') {
        <rect x="9" y="2" width="6" height="12" rx="3" />
        <path d="M19 10a7 7 0 0 1-14 0M12 19v3" />
      }
      @case ('stop') {
        <rect x="6" y="6" width="12" height="12" rx="2" />
      }
      @case ('send') {
        <path d="M14.54 10.46 4 14l16 6-6-16-3.46 10.54Z" />
      }
      @case ('dl') {
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
      }
      @case ('eye') {
        <path d="M1.8 12S5.5 5.4 12 5.4 22.2 12 22.2 12 18.5 18.6 12 18.6 1.8 12 1.8 12Z" />
        <circle cx="12" cy="12" r="3.1" />
      }
      @case ('refresh') {
        <path d="M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5" />
      }
      @case ('check') {
        <path d="M20 6 9 17l-5-5" />
      }
      @case ('minus') {
        <path d="M5 12h14" />
      }
    }
  </svg>
</ng-template>

<!-- ── Pebble bot ── -->
<ng-template #bot let-size="size" let-state="state">
  <span class="amybot {{ state || 'idle' }}" [style.width.px]="size || 44" [style.height.px]="size || 44">
    <svg viewBox="0 0 48 48" [attr.width]="size || 44" [attr.height]="size || 44" fill="none" aria-hidden="true">
      <circle class="ring r1" cx="24" cy="25" r="15" stroke="#CBB892" stroke-width="1.4" fill="none" />
      <circle class="ring r2" cx="24" cy="25" r="15" stroke="#CBB892" stroke-width="1.4" fill="none" />
      <rect x="9" y="11" width="30" height="29" rx="14.5" fill="#F4EEDF" stroke="#CBB892" stroke-width="1.2" />
      <circle cx="16.5" cy="29" r="2.4" fill="#E7C9A1" opacity=".8" />
      <circle cx="31.5" cy="29" r="2.4" fill="#E7C9A1" opacity=".8" />
      <g class="eyes">
        <circle cx="19" cy="23.5" r="3.4" fill="#314022" />
        <circle cx="29" cy="23.5" r="3.4" fill="#314022" />
        <circle cx="20.1" cy="22.4" r="1" fill="#fff" />
        <circle cx="30.1" cy="22.4" r="1" fill="#fff" />
      </g>
      <path
        class="mouth"
        d="M21 31 Q24 33 27 31"
        stroke="#A8895B"
        stroke-width="1.6"
        stroke-linecap="round"
        fill="none"
      />
      <g class="thinkdots" fill="#CBB892">
        <circle class="t1" cx="33" cy="11" r="1.5" />
        <circle class="t2" cx="37.5" cy="8" r="1.8" />
        <circle class="t3" cx="42" cy="5" r="2.1" />
      </g>
    </svg>
  </span>
</ng-template>

<!-- ── Launcher (panel closed) ── -->
@if (!isChatbot) {
  <div class="launcher-wrap">
    <button
      class="launcher"
      (pointerdown)="onLauncherPointerDown($event)"
      (pointermove)="onLauncherPointerMove($event)"
      (pointerup)="onLauncherPointerUp()"
      (pointercancel)="onLauncherPointerUp()"
      (click)="onLauncherClick()"
      aria-label="Open Agent Amy"
    >
      <ng-container *ngTemplateOutlet="bot; context: { size: 44, state: 'idle' }"></ng-container>
      @if (unread) {
        <span class="launcher-dot">1</span>
      }
    </button>
  </div>
}

<!-- ── Panel (open) ── -->
@if (isChatbot) {
  <div class="panel" [class.expanded]="isExpanded">
    <!-- Header -->
    <div class="hd">
      <div class="av">
        <ng-container
          *ngTemplateOutlet="bot; context: { size: 46, state: isInitializingChatbot ? 'thinking' : 'idle' }"
        ></ng-container>
        <span class="dot"></span>
      </div>
      <div class="id">
        <div class="nm">Agent Amy Beta Version</div>
        <div class="sub">
          <span class="live"><i></i>Online</span> · Ready to Assist
        </div>
      </div>
      <div class="acts">
        <button class="iconbtn" title="Restart conversation" (click)="clearConversation()">
          <ng-container *ngTemplateOutlet="ic; context: { name: 'refresh', size: 16 }"></ng-container>
        </button>
        <button class="iconbtn" [title]="isExpanded ? 'Shrink' : 'Expand'" (click)="toggleExpand()">
          <ng-container
            *ngTemplateOutlet="ic; context: { name: isExpanded ? 'shrink' : 'expand', size: 16 }"
          ></ng-container>
        </button>
        <button class="iconbtn" title="Minimize" (click)="toggleChatbot()">
          <ng-container *ngTemplateOutlet="ic; context: { name: 'minus', size: 18 }"></ng-container>
        </button>
      </div>
    </div>

    <!-- Scroll region -->
    <div class="scrollwrap">
      <div class="scroll">
        @if (messages.length === 1 && getInitializationOptionsMessage(); as initMsg) {
          <div class="init-hero">
            <div class="bigbot">
              <ng-container
                *ngTemplateOutlet="bot; context: { size: initializationAvatarBotSize, state: 'idle' }"
              ></ng-container>
            </div>
            <h2>{{ initializationGreetingTitle }}</h2>
            <p>{{ initializationGreetingBody }}</p>
          </div>

          <div class="init-options">
            @for (option of initMsg.options; track option; let i = $index) {
              <button
                type="button"
                class="init-option-card"
                [class.selected]="initMsg.selectedOption === option"
                [disabled]="!!initMsg.selectedOption"
                (click)="handleInitializationOption(initMsg, option)"
              >
                <span class="init-option-ic">
                  <ng-container
                    *ngTemplateOutlet="ic; context: { name: i === 0 ? 'plus' : 'folder', size: 22, sw: 1.9 }"
                  ></ng-container>
                </span>
                <span class="init-option-label">{{ option }}</span>
                <span class="init-option-sa">
                  <ng-container *ngTemplateOutlet="ic; context: { name: 'chev', size: 16 }"></ng-container>
                </span>
              </button>
            }
          </div>
        }

        @for (msg of messages; track msg.id ?? $index; let i = $index) {
          @if (!msg.initializationOptionsStyle) {
            <div class="cb-row {{ rowClass(i) }}">
              @if (msg.sender === 'Agent Amy') {
                <div class="mini-av" [class.ghost]="!isEndRun(i)">
                  <ng-container *ngTemplateOutlet="bot; context: { size: 30, state: 'idle' }"></ng-container>
                </div>
              }
              <div class="bubble">
                @if (msg.sender === 'Agent Amy' && isStartRun(i)) {
                  <div class="who">Agent Amy</div>
                }

                @if (msg.sender === 'Agent Amy') {
                  @switch (msg.type) {
                    @case ('SuccessString') {
                      <div class="agent-card">
                        <div class="okline">
                          <span class="ok-ic"
                            ><ng-container
                              *ngTemplateOutlet="ic; context: { name: 'check', size: 11, sw: 3 }"
                            ></ng-container
                          ></span>
                          {{ msg.message }}
                        </div>
                      </div>
                    }

                    @case ('ErrorString') {
                      <div class="agent-card">
                        <div class="errline">
                          <span class="err-ic"
                            ><ng-container
                              *ngTemplateOutlet="ic; context: { name: 'close', size: 11, sw: 3 }"
                            ></ng-container
                          ></span>
                          {{ msg.message }}
                        </div>
                      </div>
                    }

                    @case ('TabularData') {
                      <div class="agent-card">
                        @if (msg.message) {
                          <div>{{ msg.message }}</div>
                        }
                        @if (msg.tabularOutput) {
                          <div class="amy-table-wrap">
                            <table class="amy-table">
                              <thead>
                                <tr>
                                  <th class="amy-table-action-head"></th>
                                  @for (header of msg.tabularOutput.headers; track $index) {
                                    <th>{{ header }}</th>
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                @for (rrow of getTabularPageRows(msg); track $index) {
                                  <tr>
                                    <td class="amy-table-action-cell">
                                      <button
                                        type="button"
                                        class="table-select-btn"
                                        (click)="selectTabularRow(msg, rrow)"
                                      >
                                        Select
                                      </button>
                                    </td>
                                    @for (cell of rrow; track $index) {
                                      <td>{{ cell }}</td>
                                    }
                                  </tr>
                                }
                              </tbody>
                            </table>
                            @if (getTabularPageCount(msg.tabularOutput) > 1) {
                              <div class="amy-pager">
                                <button
                                  class="pg"
                                  [disabled]="(msg.tabularPage ?? 0) === 0"
                                  (click)="setTabularPage(msg, (msg.tabularPage ?? 0) - 1)"
                                  aria-label="Previous"
                                >
                                  ‹
                                </button>
                                @for (pi of pageArray(getTabularPageCount(msg.tabularOutput)); track pi) {
                                  <button
                                    class="pg"
                                    [class.active]="pi === (msg.tabularPage ?? 0)"
                                    (click)="setTabularPage(msg, pi)"
                                  >
                                    {{ pi + 1 }}
                                  </button>
                                }
                                <button
                                  class="pg"
                                  [disabled]="(msg.tabularPage ?? 0) === getTabularPageCount(msg.tabularOutput) - 1"
                                  (click)="setTabularPage(msg, (msg.tabularPage ?? 0) + 1)"
                                  aria-label="Next"
                                >
                                  ›
                                </button>
                                <span class="pgcount"
                                  >{{ getTabularRows(msg.tabularOutput).length }} records · page
                                  {{ (msg.tabularPage ?? 0) + 1 }} of {{ getTabularPageCount(msg.tabularOutput) }}</span
                                >
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    @case ('DocumentTabularDisplay') {
                      <div class="agent-card">
                        @if (msg.message) {
                          <div>{{ msg.message }}</div>
                        }
                        <div class="doc-table-wrap">
                          <table class="doc-table">
                            <thead>
                              <tr>
                                <th class="doc-check-col">
                                  <button
                                    type="button"
                                    class="doc-check"
                                    [class.checked]="areAllDocumentTemplatesSelected(msg)"
                                    (click)="toggleAllDocumentTemplates(msg)"
                                    aria-label="Select all templates"
                                  >
                                    @if (areAllDocumentTemplatesSelected(msg)) {
                                      <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="3.4"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <path d="M4.5 12.8 9.4 17.6 19.6 6.9" />
                                      </svg>
                                    }
                                  </button>
                                </th>
                                <th>Document Template</th>
                                <th class="doc-order-col">Order</th>
                                <th class="doc-view-col">View</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (docRow of getDocumentTemplates(msg); track docRow.key; let docIndex = $index) {
                                <tr
                                  [attr.data-doc-row]="docIndex"
                                  [class.selected]="isDocumentTemplateSelected(msg, docRow)"
                                  [class.dragging]="isDocumentTemplateDragging(msg, docRow)"
                                  [class.drop-before]="isDocumentTemplateDropBefore(msg, docIndex)"
                                  [class.drop-after]="isDocumentTemplateDropAfter(msg, docIndex)"
                                >
                                  <td class="doc-check-col">
                                    <button
                                      type="button"
                                      class="doc-check"
                                      [class.checked]="isDocumentTemplateSelected(msg, docRow)"
                                      [attr.aria-pressed]="isDocumentTemplateSelected(msg, docRow)"
                                      (click)="toggleDocumentTemplate(msg, docRow)"
                                    >
                                      @if (isDocumentTemplateSelected(msg, docRow)) {
                                        <svg
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="3.4"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <path d="M4.5 12.8 9.4 17.6 19.6 6.9" />
                                        </svg>
                                      }
                                    </button>
                                  </td>
                                  <td
                                    class="doc-name-cell"
                                    title="Drag to move"
                                    (pointerdown)="startDocumentTemplateDrag($event, msg, docRow, docIndex)"
                                  >
                                    {{ docRow.name }}
                                  </td>
                                  <td class="doc-order-col">{{ docIndex + 1 }}</td>
                                  <td class="doc-view-col">
                                    <button
                                      type="button"
                                      class="doc-view-btn"
                                      [disabled]="!isDocumentTemplateViewable(docRow)"
                                      [attr.aria-label]="
                                        isDocumentTemplateViewable(docRow) ? 'View template' : 'Preview unavailable'
                                      "
                                      [title]="
                                        isDocumentTemplateViewable(docRow) ? 'View template' : 'Preview unavailable'
                                      "
                                      (click)="viewDocumentTemplate(msg, docRow)"
                                    >
                                      <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.7"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <path
                                          d="M1.8 12S5.5 5.4 12 5.4 22.2 12 22.2 12 18.5 18.6 12 18.6 1.8 12 1.8 12Z"
                                        />
                                        <circle cx="12" cy="12" r="3.1" />
                                      </svg>
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                        <div class="doc-actions">
                          <button
                            type="button"
                            class="doc-action-btn"
                            (click)="insertDocumentTemplate(msg, 'schedulePe')"
                          >
                            + Insert Schedule PE
                          </button>
                          <button
                            type="button"
                            class="doc-action-btn"
                            (click)="insertDocumentTemplate(msg, 'sitePlan')"
                          >
                            + Insert Site Plan
                          </button>
                          <button type="button" class="doc-action-btn" (click)="triggerCustomDocumentPicker(msg)">
                            + Insert Custom Document
                          </button>
                          <button type="button" class="doc-action-btn" (click)="moveDocumentTemplates(msg, -1)">
                            ↑ Move up
                          </button>
                          <button type="button" class="doc-action-btn" (click)="moveDocumentTemplates(msg, 1)">
                            ↓ Move down
                          </button>
                        </div>
                        <div class="doc-actions">
                          <button
                            type="button"
                            class="doc-action-btn doc-action-primary"
                            [disabled]="!canGenerateContract(msg)"
                            (click)="generateContract(msg)"
                          >
                            Generate Contract
                          </button>
                        </div>
                      </div>
                    }

                    @case ('AttributeArrayTable') {
                      <div class="agent-card attr-card">
                        <div class="attr-prompt">Specify Option Attributes</div>

                        @for (field of attributeFields; track field.key) {
                          <div class="attr-field">
                            <div class="attr-label">{{ field.label }}</div>

                            <div
                              class="attr-control"
                              [class.open]="isAttributeOpen(msg, field.key)"
                              [class.disabled]="isAttributeDisabled(msg, field.key)"
                              (click)="toggleAttributeDropdown($event, msg, field.key)"
                            >
                              @if (getAttributeValue(msg, field.key); as attrValue) {
                                <span class="attr-value" [title]="attrValue">{{ attrValue }}</span>
                                <button
                                  type="button"
                                  class="attr-clear"
                                  aria-label="Clear"
                                  (click)="clearAttribute($event, msg, field.key)"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="ic; context: { name: 'close', size: 13, sw: 2.2 }"
                                  ></ng-container>
                                </button>
                              } @else {
                                <span class="attr-placeholder">{{ field.placeholder }}</span>
                              }
                              <span class="attr-chev">
                                <ng-container
                                  *ngTemplateOutlet="ic; context: { name: 'chev', size: 14, sw: 2.2 }"
                                ></ng-container>
                              </span>
                            </div>

                            @if (field.key === 'location' && isAttributeDisabled(msg, 'location')) {
                              <div class="attr-helper">No locations available for this product.</div>
                            }

                            @if (isAttributeOpen(msg, field.key)) {
                              <div class="attr-panel" (click)="$event.stopPropagation()">
                                <div class="attr-search">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                  >
                                    <circle cx="11" cy="11" r="7" />
                                    <path d="M20 20l-4-4" />
                                  </svg>
                                  <input type="text" placeholder="Search…" [(ngModel)]="attributeQuery" />
                                </div>
                                <div class="attr-list">
                                  @for (option of getFilteredAttributeOptions(msg, field.key); track option) {
                                    <button
                                      type="button"
                                      class="attr-option"
                                      [class.selected]="option === getAttributeValue(msg, field.key)"
                                      (click)="pickAttribute($event, msg, field.key, option)"
                                    >
                                      <span class="attr-option-text">{{ option }}</span>
                                      @if (option === getAttributeValue(msg, field.key)) {
                                        <span class="attr-tick">
                                          <ng-container
                                            *ngTemplateOutlet="ic; context: { name: 'check', size: 10, sw: 3.2 }"
                                          ></ng-container>
                                        </span>
                                      }
                                    </button>
                                  } @empty {
                                    <div class="attr-empty">No matches</div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }

                        <div class="doc-actions attr-actions">
                          <button type="button" class="doc-action-btn" (click)="resetAttributes(msg)">Reset</button>
                          <button
                            type="button"
                            class="doc-action-btn doc-action-primary"
                            (click)="confirmAttributes(msg)"
                          >
                            Confirm Selection
                          </button>
                        </div>
                      </div>
                    }

                    @case ('Options') {
                      <div class="agent-card">
                        @if (msg.prompt) {
                          <div>{{ msg.prompt }}</div>
                        }
                        <div class="amy-select">
                          <select
                            [(ngModel)]="msg.selectedOption"
                            [disabled]="!!msg.selectedOption"
                            (ngModelChange)="sendSelectedOption(msg)"
                          >
                            <option [ngValue]="undefined" disabled>Select…</option>
                            @for (option of msg.options; track option) {
                              <option [ngValue]="option">{{ option }}</option>
                            }
                          </select>
                          <span class="chev"
                            ><ng-container *ngTemplateOutlet="ic; context: { name: 'chev', size: 16 }"></ng-container
                          ></span>
                        </div>
                      </div>
                    }

                    @case ('Pdf') {
                      <div>
                        @if (msg.message) {
                          <div class="agent-card" style="margin-bottom: 0">
                            <div class="okline">
                              <span class="ok-ic"
                                ><ng-container
                                  *ngTemplateOutlet="ic; context: { name: 'check', size: 11, sw: 3 }"
                                ></ng-container
                              ></span>
                              {{ msg.message }}
                            </div>
                          </div>
                        }
                        @if (msg.pdfUrl && msg.pdfName) {
                          <button
                            type="button"
                            class="filecard"
                            [disabled]="!isPdfMessageViewable(msg)"
                            [title]="isPdfMessageViewable(msg) ? 'View document' : 'Preview unavailable'"
                            (click)="viewPdfMessage(msg)"
                          >
                            <span class="ic"><b>PDF</b></span>
                            <span class="meta"
                              ><span class="fn">{{ msg.pdfName }}</span
                              ><span class="fi">PDF document</span></span
                            >
                            <span class="dl"
                              ><ng-container *ngTemplateOutlet="ic; context: { name: 'eye', size: 18 }"></ng-container
                            ></span>
                          </button>
                        }
                      </div>
                    }

                    @case ('Thinking') {
                      <div class="loader">
                        <span class="spinner"></span><span>{{ msg.message }}</span>
                      </div>
                    }

                    @case ('StringSummary') {
                      <div class="summary-card">
                        <div class="summary-top">
                          <span class="summary-title">Summary</span>
                          <span class="summary-pill">&bull; Active</span>
                        </div>

                        <div class="summary-section">
                          <div class="summary-section-title">Summary Details</div>
                          <div class="summary-grid">
                            @for (row of getStringSummaryRows(msg); track row.label) {
                              <div class="summary-row">
                                <span class="summary-label">{{ row.label }}</span>
                                <button
                                  type="button"
                                  class="summary-value"
                                  [title]="'Copy ' + row.value"
                                  (click)="copyValue(row.value)"
                                >
                                  {{ row.value }}
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }

                    @default {
                      <!-- string / fallback -->
                      <div class="agent-card">
                        <span>{{ shownMessage(msg) }}</span>
                        @if (showCaret(msg)) {
                          <span class="caret"></span>
                        }
                      </div>
                    }
                  }
                } @else {
                  <div class="client-bubble">
                    @if (msg.attachmentName) {
                      <span class="attach msg-attach">
                        <span class="pf" [class.pf-docx]="isDocxAttachmentName(msg.attachmentName)">{{
                          isDocxAttachmentName(msg.attachmentName) ? 'DOCX' : 'PDF'
                        }}</span
                        ><span class="nm">{{ msg.attachmentName }}</span>
                      </span>
                    }
                    @if (msg.message) {
                      <div>{{ msg.message }}</div>
                    }
                  </div>
                }

                @if (isEndRun(i)) {
                  <div class="ts">{{ msg.ts }}</div>
                }
              </div>
            </div>
          }
        }

        <!-- Initial load / empty -->
        @if (isInitializingChatbot && messages.length === 0) {
          <div class="cb-row agent grp-end">
            <div class="mini-av">
              <ng-container *ngTemplateOutlet="bot; context: { size: 30, state: 'thinking' }"></ng-container>
            </div>
            <div class="bubble">
              <div class="loader"><span class="spinner"></span><span>Starting up…</span></div>
            </div>
          </div>
        }

        <div #bottomRef></div>
      </div>
    </div>

    <!-- Pending attachment -->
    @if (pendingAttachment) {
      <div class="attachrow">
        <span class="attach">
          <span class="pf" [class.pf-docx]="isDocxAttachmentName(pendingAttachment.name)">{{
            isDocxAttachmentName(pendingAttachment.name) ? 'DOCX' : 'PDF'
          }}</span
          ><span class="nm">{{ pendingAttachment.name }}</span>
          <span class="x" (click)="removeAttachment()">
            <ng-container *ngTemplateOutlet="ic; context: { name: 'close', size: 14 }"></ng-container>
          </span>
        </span>
      </div>
    }
    @if (attachmentError) {
      <div class="attachrow">
        <span class="attach-error">{{ attachmentError }}</span>
      </div>
    }

    @if (isRecording) {
      <div class="voicebox">
        <div class="vh">
          <span class="wave">
            @for (h of waveBars; track $index; let wi = $index) {
              <i [style.animation-delay]="wi * 0.1 + 's'" [style.height.px]="h"></i>
            }
          </span>
          Listening...<span class="timer">{{ fmtSec(recSec) }}</span>
        </div>
        <div class="vt">
          @if (liveTranscript) {
            <span
              ><span>{{ liveTranscript }}</span
              ><span class="cur"> |</span></span
            >
          } @else {
            <span class="vt-empty">Speak now - I'm transcribing.</span>
          }
        </div>
      </div>
    }
    @if (voiceError) {
      <div class="voice-error">{{ voiceError }}</div>
    }

    <!-- Composer -->
    <div class="composer">
      <div class="inbar">
        <input
          type="file"
          #fileInput
          accept=".pdf,application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          style="display: none"
          (change)="onFileSelected($event)"
        />
        <input
          type="file"
          #customDocumentInput
          accept=".pdf,application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          style="display: none"
          (change)="onCustomDocumentFileSelected($event)"
        />
        <button class="circbtn" title="Attach a document" (click)="triggerAttachmentPicker()">
          <ng-container *ngTemplateOutlet="ic; context: { name: 'clip', size: 18 }"></ng-container>
        </button>
        <button
          class="circbtn"
          [class.rec]="isRecording"
          [title]="isRecording ? 'Stop voice recording' : 'Voice message'"
          (click)="toggleVoiceRecording()"
        >
          <ng-container
            *ngTemplateOutlet="ic; context: { name: isRecording ? 'stop' : 'mic', size: isRecording ? 16 : 18 }"
          ></ng-container>
        </button>
        @if (!isRecording) {
          <div class="field-wrap">
            <div class="field">
              <textarea
                rows="1"
                #messageInput
                placeholder="Message Agent Amy…"
                [(ngModel)]="value"
                (keydown)="onComposerKeydown($event)"
                (input)="autoGrowComposer(messageInput)"
              ></textarea>
            </div>
          </div>
        }
        @if (isRecording) {
          <button class="sendbtn wide" (click)="handleSend()">
            <ng-container *ngTemplateOutlet="ic; context: { name: 'send', size: 15 }"></ng-container> Send
          </button>
        } @else {
          <button class="sendbtn" [disabled]="!canSend" (click)="handleSend()" aria-label="Send">
            <ng-container *ngTemplateOutlet="ic; context: { name: 'send', size: 17 }"></ng-container>
          </button>
        }
      </div>
      <div class="cap">Powered by <b>Agent Amy</b> · Treasure Hill Homes</div>
    </div>

    <!-- Toast -->
    <div class="toast-wrap">
      @if (toast) {
        <div class="cb-toast">
          <span class="ti"
            ><ng-container *ngTemplateOutlet="ic; context: { name: toast.icon, size: 15 }"></ng-container></span
          >{{ toast.text }}
        </div>
      }
    </div>

    <!-- Document viewer overlay -->
    @if (viewingDocument) {
      <div class="doc-viewer-overlay">
        <div class="doc-viewer-hd">
          <span class="doc-viewer-name" [title]="viewingDocument.name">{{ viewingDocument.name }}</span>
          <div class="doc-viewer-acts">
            <a
              class="iconbtn"
              [href]="viewingDocument.url"
              target="_blank"
              rel="noopener noreferrer"
              title="Open in new tab"
            >
              <ng-container *ngTemplateOutlet="ic; context: { name: 'dl', size: 15 }"></ng-container>
            </a>
            <button type="button" class="iconbtn" title="Close preview" (click)="closeDocumentViewer()">
              <ng-container *ngTemplateOutlet="ic; context: { name: 'close', size: 16 }"></ng-container>
            </button>
          </div>
        </div>
        <div class="doc-viewer-body">
          <iframe [src]="documentViewerUrl" title="Document preview" frameborder="0"></iframe>
        </div>
      </div>
    }
  </div>
}
